import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../../../shared/enums/modalId";
import { closeModal } from "../../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../../redux/store/store";

export const useNarIngestionModal = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );

  useEffect(() => {
    if (openedModalId === ModalId.NAR_INGESTION_UPLOAD_MODAL) {
      openModal(ModalId.NAR_INGESTION_UPLOAD_MODAL);
    }
    if (openedModalId === ModalId.NAR_INGESTION_RE_UPLOAD_MODAL) {
      openModal(ModalId.NAR_INGESTION_RE_UPLOAD_MODAL);
    }
  }, [openedModalId]);

  const handleCloseModal = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  return { handleCloseModal, metaData };
};
